import { EMAIL_REGEX, PASSWORD_REGEX, PHONE_NUMBER_REGEX, ROMANJI_CHARACTER_REGEX } from '@/config';
import FormErrorMessage from './formErrorMessages';

export const FormValidation = {
  Required: {
    required: {
      value: true,
      message: FormErrorMessage.Required,
    },
  },
  Email: {
    pattern: {
      value: EMAIL_REGEX,
      message: FormErrorMessage.EmailErrorMessage,
    },
  },
  PhoneNumber: {
    pattern: {
      value: PHONE_NUMBER_REGEX,
      message: FormErrorMessage.PhoneNumberErrorMessage,
    },
  },
  Password: {
    pattern: {
      value: PASSWORD_REGEX,
      message: FormErrorMessage.PasswordInvalid,
    },
  },
  RequiredWithRomanjiCharacter: {
    required: {
      value: true,
      message: FormErrorMessage.Required,
    },
    pattern: {
      value: ROMANJI_CHARACTER_REGEX,
      message: FormErrorMessage.RomanjiCharacter,
    },
  },
};
